const DEVICECLASS = require("../json/data.class.json");

/**
 * @method polygonLineStringToArray
 * @description 用于转换多边形覆盖物的字符串成数组
 * 
 */

const polygonLineStringToArray = (polygonLine) => {
  let result = polygonLine.split(";");
  result.forEach((item, index) => {
    result[index] = item.split(",");
  });
  return result;
};

/**
 * @method conversionTimeFormat
 * @description 获取指定格式的时间字符串。 
 * 月(M)、日(d)、小时(h)、分(m)、秒(s)、季度(q)可以用 1-2 个占位符
 * 年(y)可以使用 1-4 个占位符，毫秒(S)只能用 1 个 占位符
 * @author machunning
 * @param {String} stringFormat 时间格式 例如：YYYY-MM-dd hh:mm:ss
 */

const conversionTimeFormat = (timeStringFormat) => {
  let d = new Date();
  let o = {
    "M+": d.getMonth() + 1,                   
    "d+": d.getDate(),                        
    "h+": d.getHours(),                       
    "m+": d.getMinutes(),                     
    "s+": d.getSeconds(),                     
    "q+": Math.floor(( d.getMonth() + 3 ) / 3),
    "S": d.getMilliseconds() 
  };
  if (/(Y+)/.test(timeStringFormat)) {
    timeStringFormat = timeStringFormat.replace(RegExp.$1, (d.getFullYear() + "").substr(4 - RegExp.$1.length));
  }
  for (let k in o) {
    if (new RegExp('(' + k +')').test(timeStringFormat)) {
      timeStringFormat = timeStringFormat.replace(RegExp.$1, (RegExp.$1.length == 1) ? (o[k]) : (("00" + o[k]).substr(("" + o[k]).length)));
    } 
  }
  return timeStringFormat;
};

/**
 * @method transitionDirection
 * @description 将风向的数值表示转换成文字表示
 */

const transitionDirection = (data) => {
  let value = "";
  if (data >= 22.5 && data < 67.5) {
    value = "东北";
  } else if (data >= 67.5 && data < 112.5) {
    value = "东";
  } else if (data >= 112.5 && data < 157.5) {
    value = "东南";
  } else if (data >= 157.5 && data < 202.5) {
    value = "南";
  } else if (data >= 202.5 && data < 247.5) {
    value = "西南";
  } else if (data >= 247.5 && data < 292.5) {
    value = "西";
  } else if (data >= 292.5 && data < 337.5) {
    value = "西北";
  } else {
    value = "北";
  }
  return value;
};

/**
 * @method handleSleetData
 * @description 处理降水数据的情况
 */

const _handleSleetData = (data) => {
  let temp = ["无降水", "有降水"];
  return temp[data];
};

/**
 * @method handleSensorData
 * @description 处理传感器获取到的数据
 */

const handleSensorData = (sensorData) => {
  if (sensorData.data_class === "wind_direction") {
    sensorData.min_number = transitionDirection(sensorData.min_number);
    sensorData.mean_number = transitionDirection(sensorData.mean_number);
    sensorData.max_number = transitionDirection(sensorData.max_number);
  } else if (sensorData.data_class === "sleet") {
    sensorData.min_number = _handleSleetData(sensorData.min_number);
    sensorData.mean_number = _handleSleetData(sensorData.mean_number);
    sensorData.max_number = _handleSleetData(sensorData.max_number);
  } else {
    sensorData.min_number = sensorData.min_number.toFixed(2);
    sensorData.mean_number = sensorData.mean_number.toFixed(2);
    sensorData.max_number = sensorData.max_number.toFixed(2);
  }
  DEVICECLASS.forEach(item => {
    if (item.class === sensorData.data_class) {
      sensorData.unit = item.unit;
      sensorData.name = item.name;
    }
  });
  sensorData.time = sensorData.time.split("T")[0];
  return sensorData;
};

export {
  polygonLineStringToArray,
  conversionTimeFormat,
  handleSensorData,
  transitionDirection
}